import { render } from "./DbTableView.vue?vue&type=template&id=20aef866"
import script from "./DbTableView.vue?vue&type=script&lang=js"
export * from "./DbTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__